module.exports = "/packs/images/homepage/activity/gymnastic_tablet~db8adf67c1574fcc25e895632d3fcb75.jpg";